class VideoTestimonialsGrid extends HTMLElement {
	constructor() {
		super();
		this.handleLoadMore = this.handleLoadMore.bind(this);
	}

	connectedCallback() {
		this.initialVisible = parseInt(this.dataset.initialVisible) || 6;
		this.columnsDesktop = parseInt(this.dataset.columnsDesktop) || 6;
		this.columnsTablet = parseInt(this.dataset.columnsTablet) || 3;
		this.columnsMobile = parseInt(this.dataset.columnsMobile) || 2;

		this.videoItems = Array.from(this.querySelectorAll('.video-testimonials__item'));
		this.loadMoreBtn = this.querySelector('.video-testimonials__load-more-btn');

		if (this.loadMoreBtn) {
			this.loadMoreBtn.addEventListener('click', this.handleLoadMore);
		}

		// Initially hide videos beyond the visible count
		this.hideExtraVideos();
	}

	disconnectedCallback() {
		if (this.loadMoreBtn) {
			this.loadMoreBtn.removeEventListener('click', this.handleLoadMore);
		}
	}

	hideExtraVideos() {
		this.videoItems.forEach((item, index) => {
			if (index >= this.initialVisible) {
				item.setAttribute('data-hidden', 'true');
			}
		});
	}

	getCurrentColumns() {
		const width = window.innerWidth;
		if (width >= 1024) {
			return this.columnsDesktop;
		} else if (width >= 768) {
			return this.columnsTablet;
		} else {
			return this.columnsMobile;
		}
	}

	handleLoadMore() {
		const currentColumns = this.getCurrentColumns();
		const hiddenItems = this.videoItems.filter(
			item => item.getAttribute('data-hidden') === 'true'
		);

		if (hiddenItems.length === 0) {
			return;
		}

		// Show one more row
		const itemsToShow = Math.min(currentColumns, hiddenItems.length);

		for (let i = 0; i < itemsToShow; i++) {
			hiddenItems[i].removeAttribute('data-hidden');
		}

		// Hide load more button if all videos are now visible
		const stillHidden = this.videoItems.filter(
			item => item.getAttribute('data-hidden') === 'true'
		);

		if (stillHidden.length === 0) {
			const loadMoreWrapper = this.querySelector('.video-testimonials__load-more');
			if (loadMoreWrapper) {
				loadMoreWrapper.style.display = 'none';
			}
		}
	}
}

customElements.define('video-testimonials-grid', VideoTestimonialsGrid);
